var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "meeting-agenda__items-container" },
    _vm._l(_vm.agendas, function(agenda, index) {
      return _c("MeetingAgenda", { key: index, attrs: { agenda: agenda } })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }